import { render, staticRenderFns } from "./FinishFormSwitch.vue?vue&type=template&id=58f21840&scoped=true"
import script from "./FinishFormSwitch.vue?vue&type=script&lang=js"
export * from "./FinishFormSwitch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f21840",
  null
  
)

export default component.exports